import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { getDateUtil, noFormat, today, yesterday } from "../../util/formatDate";

export const useApprovalLaporan = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [shiftApprovalLaporan, setShiftApprovalLaporan] =
    useState("Pilih Shift");
  const [dateApprovalLaporan, setDateApprovalLaporan] = useState(today);
  const [dataApprovalLaporan, setDataApprovalLaporan] = useState([]);
  const [popUpApprovalLaporan, setPopUpApprovalLaporan] = useState(false);
  const [listTopPlate, setListTopPlate] = useState();

  const [listPasangKaret, setListPasangKaret] = useState();
  const [listPasangStiker, setListPasangStiker] = useState();

  const [filterMesin, setFilterMesin] = useState("Pilih Mesin");
  const [isRefresh, setIsRefresh] = useState(false);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLaporanOperator`,
      {
        tim: dataUser.tim,
        date: getDateUtil(dateApprovalLaporan),
        shift: shiftApprovalLaporan,
      },
      dataUser.auth,
      setDataApprovalLaporan,
      ""
    );

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLaporanPasangKaret`,
      {
        tim: dataUser.tim,
        date: getDateUtil(dateApprovalLaporan),
        shift: shiftApprovalLaporan,
        isKepala: false,
        type: "approvalKepala",
      },
      dataUser.auth,
      setListPasangKaret,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLaporanPasangStiker`,
      {
        tim: dataUser.tim,
        date: getDateUtil(dateApprovalLaporan),
        shift: shiftApprovalLaporan,
        isKepala: false,
        type: "approvalKepala",
      },
      dataUser.auth,
      setListPasangStiker,
      ""
    );
    setIsRefresh(false);
  }, [shiftApprovalLaporan, dateApprovalLaporan, isRefresh]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getLaporanOperator`,
      {
        tim: dataUser.tim,
        date: getDateUtil(dateApprovalLaporan),
        shift: shiftApprovalLaporan,
      },
      dataUser.auth,
      setDataApprovalLaporan,
      ""
    );

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getDataTopPlate`,
      {
        tim: dataUser.tim,
        date: getDateUtil(dateApprovalLaporan),
        shift: shiftApprovalLaporan,
        isKepala: false,
        isAdmin: false,
      },
      dataUser.auth,
      setListTopPlate,
      ""
    );
  }, [shiftApprovalLaporan]);

  const handleKirim = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/submitLaporanKepala`,
      {
        tim: dataUser.tim,
        approvedBy: dataUser.name,
        shift: shiftApprovalLaporan,
        date: getDateUtil(dateApprovalLaporan),
        dataTopPlate: listTopPlate,
        yesterday: getDateUtil(yesterday),
        dateApprove: noFormat,
      },
      dataUser.auth,
      "",
      ""
    );
    setPopUpApprovalLaporan(true);
  };

  const searchFeatureMesinInjeksi = () => {
    if (filterMesin !== "Pilih Mesin") {
      let searchName = [];
      dataApprovalLaporan &&
        dataApprovalLaporan.forEach((value) => {
          if (value.mesin === filterMesin) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataApprovalLaporan && dataApprovalLaporan;
    }
  };
  let dataTempMesinInjeksi = searchFeatureMesinInjeksi(filterMesin);

  let filterMesinSelect = [];

  dataApprovalLaporan &&
    dataApprovalLaporan.forEach((e) => {
      let check =
        filterMesinSelect && filterMesinSelect.find((o) => o === e.mesin);
      if (!check) {
        filterMesinSelect.push(e.mesin);
      }
    });

  return {
    dataUser,
    shiftApprovalLaporan,
    setShiftApprovalLaporan,
    handleKirim,
    popUpApprovalLaporan,
    setPopUpApprovalLaporan,
    setDateApprovalLaporan,
    dateApprovalLaporan,
    listTopPlate,
    listPasangKaret,
    filterMesin,
    setFilterMesin,
    dataTempMesinInjeksi,
    filterMesinSelect,
    setIsRefresh,
    listPasangStiker,
  };
};
